import React from 'react';
import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import { Theme, ThemeProps } from '@theme/base';
import { TestId } from '@components/test-ids';
import { useI18NextContext } from '@components/hooks';
import { ComponentContainer, SectionSeparator } from '@styles/layout';
import { HelpCategoryListItem } from '@model/iceberg/help-centre';
import { HelpCentreInfoTile } from './HelpCentreInfoTile';

const Container = styled.div(({ theme }: ThemeProps) => ({
  margin: 0,
  ...(theme.custom.typography.paragraph as any)
}));

export interface HelpTileGroupProps {
  theme: Theme;
  categories: HelpCategoryListItem[];
}

const PageTitle = styled.h2({
  marginTop: 0
});

export const HelpCentreTileGroupComponent = ({ categories, theme }: HelpTileGroupProps) => {
  const t = useI18NextContext();
  const renderInfoTiles = () =>
    categories.map((category: HelpCategoryListItem) => (
      <Grid item key={category.title} xs={12} md={4}>
        <HelpCentreInfoTile key={category.title} tile={category} />
      </Grid>
    ));
  return (
    <Container data-testid={TestId.helpTileGroup}>
      <ComponentContainer>
        <SectionSeparator />
        <PageTitle>{t('help-centre__topics-title')}</PageTitle>
        <Grid container spacing={theme.custom.gridSpacing.default}>
          {renderInfoTiles()}
        </Grid>
        <SectionSeparator />
      </ComponentContainer>
    </Container>
  );
};

export const HelpCentreTileGroup = withTheme(HelpCentreTileGroupComponent);
